module.exports = __webpack_public_path__ + "static/media/1self.c859a53d.svg";